import gql from 'graphql-tag';

export default gql`
subscription {
    onCreateAdvertiser {
        __typename
        id
        name
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Roles/NewSubscription.js